export default {
  "breadcrumbs.home": "HOME",
  "breadcrumbs.event": "Events",
  "breadcrumbs.bbt.event": "", // No EN BBT
  "breadcrumbs.event.archive": "Past Events",
  "breadcrumbs.login": "Login My Page",
  "breadcrumbs.signup": "Sign up",
  "breadcrumbs.usage": "Terms of use / Postings",

  "breadcrumbs.interview": "Interviews & Blogs",
  "breadcrumbs.bulletinboard": "The Shared Bulletin Board",
  "breadcrumbs.news": "News",

  // register page [only support Japanese]
  "breadcrumbs.register": "同意事項",
  "breadcrumbs.register.form": "投稿アカウント新規登録",
  "breadcrumbs.register.form_check": "投稿アカウント新規登録",
  "breadcrumbs.register.complete": "投稿アカウント新規登録",

  "breadcrumbs.contact": "Agreed Terms",
  "breadcrumbs.contact.form": "Contact us",
  "breadcrumbs.contact.confirm": "Contact us",
  "breadcrumbs.contact.complete": "Contact us",

  "breadcrumbs.report": "Event Reports",
  "breadcrumbs.bbt.report": "",

  "breadcrumbs.sandbox": "",
} as const;
